import { useState,useEffect } from "react";
import axios from "axios";

function EditTechnician({technician,onClose}){

const [username,setUsername]=useState(
technician.username
);

const [email,setEmail]=useState(
technician.email
);

const [employeeCode,setEmployeeCode]=useState(
technician.employee_code
);

const [mobile,setMobile]=useState(
technician.mobile
);

const [address,setAddress]=useState(
technician.address || ""
);

const [departmentId,setDepartmentId]=useState(
technician.department_id || ""
);

const [designationId,setDesignationId]=useState(
technician.designation_id || ""
);

const [skills,setSkills]=useState(
technician.skills || ""
);

const [joiningDate,setJoiningDate]=useState(
technician.joining_date || ""
);

const [experienceYears,setExperienceYears]=useState(
technician.experience_years || ""
);

const [status,setStatus]=useState(
technician.status || "Active"
);

const [departments,setDepartments]=useState([]);
const [designations,setDesignations]=useState([]);

useEffect(()=>{

loadDepartments();
loadDesignations();

},[]);

const loadDepartments=async()=>{

try{

const token=
localStorage.getItem("token");

const response=
await axios.get(

"https://saleupcall.com/api/Department/get-departments.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setDepartments(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const loadDesignations=async()=>{

try{

const token=
localStorage.getItem("token");

const response=
await axios.get(

"https://saleupcall.com/api/Designation/get-designations.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setDesignations(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const updateTechnician=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const response=
await axios.post(

"https://saleupcall.com/api/Technician/edit-technician.php",

{

id:technician.id,

username,
email,

employee_code:employeeCode,
mobile,
address,

department_id:departmentId,
designation_id:designationId,

skills,
joining_date:joiningDate,
experience_years:experienceYears,
status

},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Technician Updated"
);

onClose();

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={updateTechnician}>

<div className="row">

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Username"
value={username}
onChange={(e)=>
setUsername(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Email"
value={email}
onChange={(e)=>
setEmail(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Employee Code"
value={employeeCode}
onChange={(e)=>
setEmployeeCode(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Mobile"
value={mobile}
onChange={(e)=>
setMobile(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<select
className="form-select form-select-sm"
value={departmentId}
onChange={(e)=>
setDepartmentId(e.target.value)
}
>

<option value="">
Select Department
</option>

{

departments.map(
(item)=>(

<option
key={item.id}
value={item.id}
>

{item.department_name}

</option>

)

)

}

</select>

</div>

<div className="col-md-6 mb-2">

<select
className="form-select form-select-sm"
value={designationId}
onChange={(e)=>
setDesignationId(e.target.value)
}
>

<option value="">
Select Designation
</option>

{

designations.map(
(item)=>(

<option
key={item.id}
value={item.id}
>

{item.designation_name}

</option>

)

)

}

</select>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Skills"
value={skills}
onChange={(e)=>
setSkills(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
type="date"
className="form-control form-control-sm"
value={joiningDate}
onChange={(e)=>
setJoiningDate(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
type="number"
className="form-control form-control-sm"
placeholder="Experience Years"
value={experienceYears}
onChange={(e)=>
setExperienceYears(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<select
className="form-select form-select-sm"
value={status}
onChange={(e)=>
setStatus(e.target.value)
}
>

<option value="Active">
Active
</option>

<option value="Inactive">
Inactive
</option>

</select>

</div>

<div className="col-md-12 mb-2">

<textarea
className="form-control form-control-sm"
rows="2"
placeholder="Address"
value={address}
onChange={(e)=>
setAddress(e.target.value)
}
/>

</div>

</div>

<div className="text-end mt-2">

<button
className="btn btn-primary btn-sm"
>

<i className="bi bi-check-lg me-1"></i>

Update

</button>

</div>

</form>

);

}

export default EditTechnician;